import { TextResource } from "@Utilities/TextResource";

export class Product
{
	public CurrencySymbol;
	public Exclusive;
	public HasPriceRange;
	public HasSavings;
	public ImageLink;
	public ImageLinkLarge;
	public ImageLinkMedium;
	public ImageLinkXLarge;
	public IsOnClearance;
	public IsOnSale;
	public IsPreOrder;
	public IsSingleSize;
	public IsSingleSizeNotStandard;
	public Link;
	public MadeByUs;
	public MaxOriginalPrice;
	public MaxPrice;
	public MinOriginalPrice;
	public MinPrice;
	public ProductID;
	public Rating;
	public RatingDescription;
	public Ratings;
	public RefreshExclusiveMadeByUsTag;
	public RefreshShowExclusive;
	public RRLink;
	public Savings;
	public Sizes;
	public Title;
	public UtmParameter;

	constructor(productID, sizes, title, link, imageLink, price, isOnClearance, isOnSale, isPreOrder, rating, currencySymbol, exclusive, madeByUs, rrLink, utmParameter)
	{
		let savings = 0;
		let sizeCount = 0;
		let sizeStandard = false;
		const youSaveThreshold = 0.05;
		let maxPrice = 0;
		let minPrice = 0;
		let maxRegularPrice = 0;
		let minRegularPrice = 0;
		price = (price * 1);

		if (sizes.length > 0)
		{
			for (let k = 0; k < sizes.length; k++)
			{
				if (sizes[k].DisplayPrice > maxPrice || maxPrice === 0) maxPrice = sizes[k].DisplayPrice.toFixed(2);
				if (sizes[k].DisplayPrice < minPrice || minPrice === 0) minPrice = sizes[k].DisplayPrice.toFixed(2);
				if (sizes[k].RegularPrice > maxRegularPrice || maxRegularPrice === 0) maxRegularPrice = sizes[k].RegularPrice.toFixed(2);
				if (sizes[k].RegularPrice < minRegularPrice || minRegularPrice === 0) minRegularPrice = sizes[k].RegularPrice.toFixed(2);
			}
		}
		else
		{
			maxPrice = price.toFixed(2);
			minPrice = price.toFixed(2);
			maxRegularPrice = price.toFixed(2);
			minRegularPrice = price.toFixed(2);
		}

		this.CurrencySymbol = currencySymbol;
		this.Exclusive = exclusive;
		this.ImageLink = imageLink;
		this.ImageLinkMedium = imageLink.replace("/1-5/", "/1-4/");
		this.ImageLinkLarge = imageLink.replace("/1-5/", "/1-21/");
		this.ImageLinkXLarge = imageLink.replace("/1-5/", "/1-2/");
		this.IsOnSale = isOnSale;
		this.IsPreOrder = isPreOrder;
		this.Link = link;
		this.MadeByUs = madeByUs;
		this.MaxOriginalPrice = maxRegularPrice;
		this.MaxPrice = maxPrice;
		this.MinOriginalPrice = minRegularPrice;
		this.MinPrice = minPrice;
		this.ProductID = productID;
		this.Rating = rating;
		this.RefreshExclusiveMadeByUsTag = (madeByUs || exclusive);
		this.RefreshShowExclusive = (exclusive && !(madeByUs && (isPreOrder || isOnClearance || isOnSale)));
		this.RRLink = rrLink;
		this.Sizes = sizes;
		this.Title = title.replace(/"/g, '\\"');
		this.UtmParameter = utmParameter;

		// Calculations
		this.HasPriceRange = this.MinPrice > 0 && this.MinPrice !== this.MaxPrice;

		// Ratings
		if (this.Rating > 0)
		{
			let description = TextResource.GetTextByCulture('Word_Stars');
			const ratingMod = this.Rating % 1;
			const ratings = [];
			let currentRating = "";

			if (this.Rating === 1)
			{
				description = TextResource.GetTextByCulture('Word_Star');
			}

			for (let j = 1; j <= 5; j++)
			{
				if (j <= this.Rating)
				{
					currentRating = "rating-star-filled";
				}
				else if (j > this.Rating && this.Rating > j - 1)
				{
					if (ratingMod === 0)
					{
						currentRating = "rating-star-empty";
					}
					else if (ratingMod <= 0.5)
					{
						currentRating = "rating-star-50";
					}
					else if (ratingMod > 0.5)
					{
						currentRating = "rating-star-filled";
					}
				}
				else
				{
					currentRating = "rating-star-empty";
				}

				ratings.push(currentRating);
			}

			this.RatingDescription = this.Rating + " " + description;
			this.Ratings = ratings;
		}

		if (this.Sizes.length)
		{
			sizeCount = this.Sizes.length;

			for (let i = 0; i < this.Sizes.length; i++)
			{
				if (i === 0 && this.Sizes.length === 1)
				{
					if (this.Sizes[i].Size === "ST" || this.Sizes[i].Size === "one-size")
					{
						sizeStandard = true;
					}
				}
			}
		}

		this.IsSingleSize = sizeCount <= 1;
		this.IsSingleSizeNotStandard = !sizeStandard;

		savings = 1.0 - this.MinPrice / this.MaxOriginalPrice;

		if (savings > youSaveThreshold)
		{
			this.HasSavings = true;
			this.IsOnClearance = isOnClearance;
			this.Savings = Math.round(savings * 100);
		}
		else
		{
			this.HasSavings = false;
			this.IsOnClearance = false;
			this.Savings = 0;
		}
	}
}